module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am1.ad37aac9aae78cfeb1581b3a7e20a42f.png";